export const DATE_PICKER_CONFIG = {
  WIDTH: 'w-[164px]',
  FORMAT: 'dd.mm.yy',
  PLACEHOLDER: 'JJ.MM.AAAA',
} as const;
